import Chip from '@mui/material/Chip';

export const statusFormatter = (cell: any) => {
  switch (cell) {
    case 'red':
    case 'error': {
      return <Chip color="error" label="Red" />;
    }
    case 'yellow':
    case 'amber':
    case 'warning': {
      return <Chip color="warning" label="Yellow" />;
    }
    case 'green':
    case 'success': {
      return <Chip color="success" label="Green" />;
    }
    default: {
      return <Chip label={cell} />;
    }
  }
};
